module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-common', {
    attrs: {
      "type": "img",
      "has-comments": _vm.hasComments,
      "detail": _vm.detail
    }
  }, [_c('div', {
    staticClass: "m-header"
  }, [_c('h2', {
    staticClass: "title f-taj"
  }, [_vm._v(_vm._s(_vm.detail.title))]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.getTime(_vm.detail.date)))]), _vm._v(" "), (_vm.detail.authors) ? _c('span', {
    staticClass: "authors"
  }, [_vm._v(_vm._s(_vm.detail.authors))]) : _vm._e(), _vm._v(" "), (_vm.detail.source) ? _c('span', {
    staticClass: "copyfrom"
  }, [_vm._v(_vm._s(_vm.detail.source))]) : _vm._e()])]), _vm._v(" "), (_vm.detail.type == 'image') ? _c('div', {
    staticClass: "m-img"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.detail.medias), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('img', {
      attrs: {
        "src": _vm.webp(item.image)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "summary tj"
    }, [_c('pre', {
      staticClass: "f-pre"
    }, [_vm._v(_vm._s(item.description))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })])]) : _vm._e(), _vm._v(" "), _c('news-related', {
    attrs: {
      "list": _vm.detail.extend
    }
  }), _vm._v(" "), _c('comment-normal', {
    attrs: {
      "comments": _vm.comments
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a276728!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-img.vue
// module id = 837
// module chunks = 2